import React, { useEffect } from 'react';
import classNames from 'classnames';
import Icon from '../Icon';
import { useTranslation } from 'react-i18next';

import SnackbarTypes from './SnackbarTypes';

const iconClasses = {
  [SnackbarTypes.INFO]: 'notifications-info',
  [SnackbarTypes.WARNING]: 'notifications-warning',
  [SnackbarTypes.SUCCESS]: 'notifications-success',
  [SnackbarTypes.ERROR]: 'notifications-error',
};

const SnackbarItem = ({ options, onClose }) => {
  const handleClose = () => onClose(options.id);
  const { t } = useTranslation('ViewerTool');

  useEffect(() => {
    if (options.autoClose) {
      setTimeout(() => handleClose(), options.duration);
    }
  }, []);

  const typeClasses = {
    [SnackbarTypes.INFO]: 'bg-[#1F313B]',
    [SnackbarTypes.WARNING]: 'bg-[#ebe5c4]',
    [SnackbarTypes.SUCCESS]: 'bg-[#c6d9bf]',
    [SnackbarTypes.ERROR]: 'bg-[#dabdbe]',
  };

  const hidden =
    'duration-300 transition-all ease-in-out h-0 opacity-0 pt-0 mb-0 pb-0';

  return (
    <div
      className={classNames(
        `${options.visible ? '' : hidden} sb-item`,
        typeClasses[options.type]
      )}
    >
      <div className="flex text-[#fff]">
        <div
          onClick={handleClose}
          className="absolute right-0 top-0 mr-2 mt-2 flex h-5 w-5 items-center justify-center rounded-full text-[#0944b3]"
        >
          <Icon name="close" className="h-5 w-5 text-[#fff]" />
        </div>
        <Icon name={iconClasses[options.type]} className="mt-[1px] h-5 w-5" />
        <div className="ml-2 flex-col">
          {/* </span> */}
          {options.title && (
            <div className="break-normal text-lg font-bold">
              {t(options.title)}
            </div>
          )}
          {options.message && (
            <div className="break-normal text-base">{t(options.message)}</div>
          )}
        </div>
      </div>
    </div>
  );
};

export default SnackbarItem;
